export type AuthProvider = 'none' | 'google' | 'okta' | 'keycloak';

export interface UiConfig {
  authProvider: AuthProvider;
  oidcIssuer: string;
  oidcClientId: string;
  googleClientId: string;
  oktaDomain: string;
  oktaClientId: string;
}

declare global {
  interface Window {
    __UC_CONFIG__?: Partial<UiConfig>;
  }
}

function envProvider(): AuthProvider {
  if (process.env.REACT_APP_KEYCLOAK_AUTH_ENABLED === 'true') return 'keycloak';
  if (process.env.REACT_APP_GOOGLE_AUTH_ENABLED === 'true') return 'google';
  if (process.env.REACT_APP_OKTA_AUTH_ENABLED === 'true') return 'okta';
  return 'none';
}

function envIssuer(): string {
  const url = (process.env.REACT_APP_KEYCLOAK_URL || '').replace(/\/$/, '');
  const realm = process.env.REACT_APP_KEYCLOAK_REALM_ID || '';
  if (url && realm) return `${url}/realms/${realm}`;
  return url;
}

/**
 * Runtime configuration. Values injected at container start through
 * window.__UC_CONFIG__ (see public/config.js) take precedence over the
 * build-time REACT_APP_* variables, so one static build works everywhere.
 */
export function getConfig(): UiConfig {
  const runtime = (typeof window !== 'undefined' && window.__UC_CONFIG__) || {};
  return {
    authProvider: runtime.authProvider || envProvider(),
    oidcIssuer: runtime.oidcIssuer || envIssuer(),
    oidcClientId:
      runtime.oidcClientId || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
    googleClientId:
      runtime.googleClientId || process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    oktaDomain: runtime.oktaDomain || process.env.REACT_APP_OKTA_DOMAIN || '',
    oktaClientId:
      runtime.oktaClientId || process.env.REACT_APP_OKTA_CLIENT_ID || '',
  };
}

export function isAuthEnabled(): boolean {
  return getConfig().authProvider !== 'none';
}
